import { useMutation } from "@tanstack/react-query";

import { graphql } from "../__generated__/mcs_backend_v1";
import { mcsGqlClient } from "../utils/mcsGqlClient";

import type { CreatePhiFileReferenceMutationVariables } from "../__generated__/mcs_backend_v1/graphql";

export const CREATE_PHI_FILE_REFERENCE = graphql(`
  mutation CreatePhiFileReference($input: CreatePhiFileReferenceInput!) {
    phiFileReferenceCreate(input: $input) {
      phiFileReference {
        id
        claimCode
      }
      s3UploadInfo {
        uploadUrl
      }
    }
  }
`);

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useCreatePhiFileReferenceMut = () => {
  return useMutation({
    mutationKey: ["CREATE_PHI_FILE_REFERENCE"],
    mutationFn: async (variables: CreatePhiFileReferenceMutationVariables["input"]) => {
      return await mcsGqlClient.request(CREATE_PHI_FILE_REFERENCE, { input: variables });
    },
  });
};
